export default __webpack_public_path__ + "static/media/img_login_register.bce40f92.png";